module.exports = __webpack_public_path__ + "img/not_found_image.3c070c7c.jpg";